import axios from 'axios';
import axiosInstance from '../../../_utils/axiosConfig';

let Ach : any = {};

Ach.submitForm = async (data:any)=>{
   return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/achat/billet/avion`,data)
}

export default Ach;